import { render, staticRenderFns } from "./BCXRoundWhiteCheckbox.vue?vue&type=template&id=d40ecd1e&scoped=true"
import script from "./BCXRoundWhiteCheckbox.vue?vue&type=script&lang=ts"
export * from "./BCXRoundWhiteCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./BCXRoundWhiteCheckbox.vue?vue&type=style&index=0&id=d40ecd1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40ecd1e",
  null
  
)

export default component.exports